"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function OurStory() {
  const {
    ref: imageRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="our-story" className="relative bg-background ![padding:96px_32px_50px_32px] ![margin:-70px_0px_-40px_0px]">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className="space-y-6">
            <h2 className="font-display font-bold text-foreground leading-tight !text-5xl ![margin:-80px_0px_24px_0px]">Our Story</h2>
            <div className="space-y-4 text-lg text-muted-foreground leading-relaxed">
              <p>Paolo D'Angelo &amp; Raamon Newman are the co-founders of New Mavericks. <br /><br />They are CEO Leadership Development &amp; Business Performance Partners, who protect &amp; enhance CEO's &amp; their business achievement, progress &amp; fulfillment by developing their leadership consciousness to have the mental capacity and skill in action to create extraordinary value, billions in values, in great health.</p>
              <p>They’re the co-authors of the book: <Link to="https://www.amazon.com/Science-Protection-Impactful-Leadership-Decisions/dp/1735345849/ref=sr_1_1?crid=1MBHIA4MAPRJL&dib=eyJ2IjoiMSJ9.9qmsWu42wx8qiTQMRWB-B2ZIVHHAupxjvMBT1IyifIAz9b90o9mkuV5E6tYkBQE7DEMt9vUHGCZuMAJsYHf6BVhDMIV4gKk50likNP1_RuJ5UQoqSKrKBBJhLBlXs96Dv6yfO-4nQJUqtKun5O3IUhJlFxohML0fsD01zTs5wnRDrJLUzCvgEH4BXib167i8DN12GzjtzwHP7MKydEmJfN5hSwvjtM_yD-2Qhftw0g.QKkpudWpyoJ7YSAyBqrXZ1lUii-UalH6fQ8VYVNCQMA&dib_tag=se&keywords=raamon&qid=1771212226&sprefix=ramon%2Caps%2C854&sr=8-1" className="font-bold text-accent hover:underline" newTab>The Science of Protection: Making High Pressure Impactful Leadership Decisions that Protect &amp; Enhance You and Everyone</Link></p>
              <p className="text-foreground font-medium">Their New Maverick mindset is to raise leadership consciousness to ts highest level to expand possibilities, challenge conventions, and deliver results that matter to all stakeholders.</p>
            </div>
          </div>

          {}
          <div className="relative">
            <div ref={imageRef} className={`
                relative overflow-hidden rounded-lg
                transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]
                ${isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-5 scale-98"}
                hover:scale-102
                group
              `} style={{
            transitionDuration: "150ms"
          }}>
              <div className={`
                relative
                ${isVisible ? "scale-102" : "scale-100"}
                transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
              `}>
                <img src="https://sincere-skink.10web.cloud/wp-content/uploads/2026/02/NM-Team-shot.png" alt="Our Story" className="w-full h-auto object-cover rounded-lg ![margin:30px_0px_0px_0px]" />
                <div className={`
                  absolute inset-0 rounded-lg
                  ${isVisible ? "shadow-[inset_0_2px_16px_rgba(0,0,0,0.2)]" : "shadow-none"}
                  transition-shadow duration-[var(--duration-medium)]
                `} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}